import { CircularProgress, Icon, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { agent } from 'helpers/agent';
import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { toast } from 'react-toastify';
import { API_MYEDUZZ } from 'settings';
import createShowIf from 'v2/components/Shared/createShowIf';

interface IFile {
  name: string;
  id: any;
}

interface IProps {
  onSuccess: any;
}

export default function Uploader(props: IProps) {
  const [file, setFile] = useState<IFile>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const ShowIf = createShowIf<boolean>();

  const removeFile = () => {
    setFile(null);
  };

  const onDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles && acceptedFiles[0];
      const fetchData = async () => {
        try {
          setIsLoading(true);
          const formData = new FormData();
          formData.append('upload_type', 'cnt_divulg');
          formData.append('file', file);
          const { data } = await agent.post(`${API_MYEDUZZ}/files`, formData);
          const newFile: IFile = { id: data.data.upload_id, name: file.name };
          setFile(newFile);
          setIsLoading(false);
          if (props.onSuccess) props.onSuccess(newFile);
        } catch (error) {
          toast.error(error.message);
          setIsLoading(false);
          setFile(null);
        }
      };
      fetchData();
    },
    [props]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    preventDropOnDocument: true,
  });

  if (isLoading) {
    return (
      <div style={{ width: '100%', borderStyle: 'dashed', padding: 16, textAlign: 'center', color: '#192541' }}>
        <CircularProgress />
      </div>
    );
  }

  if (file) {
    return (
      <List>
        <ListItem>
          <ListItemText primary={file.name} />
          <ListItemSecondaryAction>
            <IconButton edge='end' aria-label='delete' onClick={removeFile}>
              <ClearIcon />
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
      </List>
    );
  }
  return (
    <div {...getRootProps()}>
      <input {...getInputProps()} multiple={false} />
      <div style={{ width: '100%', borderStyle: 'dashed', padding: 16, textAlign: 'center', color: '#192541' }}>
        <Icon>backup</Icon>
        <ShowIf value={isDragActive} compare={{ eq: true }}>
          <p>Clique ou arraste o arquivo nessa área</p>
        </ShowIf>
        <ShowIf value={isDragActive} compare={{ diff: true }}>
          <p>Clique aqui para adicionar o arquivo</p>
        </ShowIf>
      </div>
    </div>
  );
}
